import React, { type Dispatch, type SetStateAction } from 'react';
import { Typography, Box, Paper } from '@mui/material';
import SystemAccordionList from '../SystemAccordionList';
import PlumbingSystemFields, { defaultPlumbingSystem } from '../PlumbingSystemFields';
import type { PlumbingSystemValues } from '../PlumbingSystemFields';
import MediaUploadSection from '../../../../sharedModules/mediaUpload/MediaUploadSection';
import type { ManufacturerOption } from '../../hooks/useHomeServiceManufacturers';
import { sectionHeaderSx } from './inspectionReportFormStyles';

interface PlumbingInspectionSectionProps {
  plumbingSystems: PlumbingSystemValues[];
  setPlumbingSystemsWithDirty: Dispatch<SetStateAction<PlumbingSystemValues[]>>;
  plumbingManufacturers: ManufacturerOption[];
  plumbingSystemPhotos: File[][];
  updateSystemPhotos: (type: 'hvac' | 'plumbing', index: number, files: File[]) => void;
}

const PlumbingInspectionSection: React.FC<PlumbingInspectionSectionProps> = ({
  plumbingSystems,
  setPlumbingSystemsWithDirty,
  plumbingManufacturers,
  plumbingSystemPhotos,
  updateSystemPhotos,
}) => (
  <Paper variant="outlined" sx={{ mb: 3, overflow: 'hidden' }}>
    <Typography sx={sectionHeaderSx}>Plumbing</Typography>
    <Box sx={{ p: 2 }}>
      <SystemAccordionList<PlumbingSystemValues>
        sectionLabel="Plumbing"
        systems={plumbingSystems}
        onSystemsChange={setPlumbingSystemsWithDirty}
        defaultSystem={defaultPlumbingSystem}
        renderFields={(sys, idx, onChange) => (
          <>
            <PlumbingSystemFields values={sys} onChange={onChange} manufacturers={plumbingManufacturers} />
            <MediaUploadSection
              label={`Plumbing System ${idx + 1} Photos`}
              files={plumbingSystemPhotos[idx] || []}
              onChange={(files) => updateSystemPhotos('plumbing', idx, files)}
            />
          </>
        )}
      />
    </Box>
  </Paper>
);

export default PlumbingInspectionSection;
